import {Grid} from '@material-ui/core';
import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import {FormWrapper} from 'Quoting/components/shared/QuoteFormWrapper';
import React from 'react';
import {CheckboxInputGrid, MappingState} from '../../../../shared/CheckboxInputGrid';
import {getParentSchedulePath} from '../Common/PropertyPaths';

const FixedBenefitBasicBlock = () => {
  const {getBenefitLabelMapping} = useQuoteField();

  const benefit = 'healthScreeningDetails';
  const path = getBenefitLabelMapping(`${benefit}FixedBenefit`, `${getParentSchedulePath(0)}.${benefit}`, {
    type: 'options',
    flag: 'isOptionApplied',
  });
  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'fixed-benefit-basic-row-1'},
      items: [
        {
          key: 'benefit-amount',
          element: (
            <QuoteFormElement elementType="Text" label="Benefit Amount" type="number" value={0} id={'benefit-amount'} />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: 'preventive',
          element: (
            <QuoteFormElement
              elementType="FormControl"
              controlType="switch"
              label="Preventive"
              checked={false}
              id={'preventive'}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormRowGrid rows={rows} />
        <FormWrapper title="Basic" collapsible withSeparator>
          {Array.isArray([]) && <CheckboxInputGrid state={path} gridLength={4} />}
        </FormWrapper>
      </Grid>
    </Grid>
  );
};

const VariableBenefitCategoriesBlock = () => {
  const {getBenefitLabelMapping} = useQuoteField();

  const paths: Array<MappingState[]> = [];
  const benefit = 'healthScreeningDetails';
  for (let cat of []) {
    paths[cat.id] = getBenefitLabelMapping(
      `${benefit}VariableCategory${cat.id}`,
      `${getParentSchedulePath(0)}.${benefit}`,
      {type: 'options', flag: 'isOptionApplied'}
    );
  }

  return (
    <>
      {Array.isArray([]) &&
        [].map(category => (
          <FormWrapper title={category.name} collapsible withSeparator key={category.id}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <QuoteFormElement
                  elementType="Text"
                  label="Benefit Amount"
                  value={category.benefitAmount}
                  type="number"
                  id={'benefit-amount'}
                />
              </Grid>
              {category.name == 'Category 1' && (
                <Grid item xs={12} md={6}>
                  <QuoteFormElement
                    elementType="FormControl"
                    controlType="switch"
                    label="Preventive"
                    checked={category?.preventive}
                    id={'preventive'}
                  />
                </Grid>
              )}
              <FormWrapper title="Basic" withSeparator>
                {Array.isArray(category.appliedBenefits) && (
                  <Grid item xs={12}>
                    <CheckboxInputGrid state={paths[category.id]} gridLength={4} />
                  </Grid>
                )}
              </FormWrapper>
            </Grid>
          </FormWrapper>
        ))}
    </>
  );
};

export const HealthScreeningServices = () => {
  const {getBenefitLabelMapping} = useQuoteField();
  const benefit = 'healthScreeningDetails';
  const path = getBenefitLabelMapping(`${benefit}Exclusions`, `${getParentSchedulePath(0)}.${benefit}`, {
    type: 'exclusions',
    flag: 'isExclusion',
  });

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'health-screening-services-row-1'},
      items: [
        {
          key: 'type-of-benefit',
          element: (
            <QuoteFormElement
              elementType="Select"
              label="Type of Benefit"
              options={[]}
              value={''}
              id={'typeOfBenefit'}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: 'time-period',
          element: (
            <QuoteFormElement elementType="Select" label="Time period" options={[]} value={''} id={'timeperiod'} />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return (
    <Grid container>
      <FormRowGrid rows={rows} />
      <FixedBenefitBasicBlock />
      <VariableBenefitCategoriesBlock />
      <Grid item xs={12}>
        <FormWrapper
          title={<span style={{textTransform: 'uppercase', color: '#2f3847', fontSize: '0.875rem'}}>Exclusions</span>}
          collapsible
        >
          <CheckboxInputGrid state={path} gridLength={4} />
        </FormWrapper>
      </Grid>
    </Grid>
  );
};
